<template>
  <div class="p-5 w-full h-full overflow-scroll scrolling-touch">

    <div class="">
      <PhoneArea :wallpaper="require('./img/stained-glass-512.jpg')" :maxWidth="414" class="full mx-2">
        <ThankYouCanvas>
          <ThankYouLayoutChurch></ThankYouLayoutChurch>
        </ThankYouCanvas>
      </PhoneArea>
    </div>

    <!--
    <div class="democanvas">
      <ThankYouCanvas></ThankYouCanvas>
    </div>
    -->
    <!--
    <div class="democanvas">
    </div>
    -->

  </div>
</template>

<script>
export default {
  mixins: [
    require('../../Reusable/O3DCompos').O3DCompos
  ],
  mounted () {
    window.dispatchEvent(new Event('resize'))
  }
}
</script>

<style>
.democanvas{
  width: 100%;
  max-width: 480px;
  height: 480px;
}
</style>
